var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"data-app":"","full-height":false}},[_c(_vm.proxyType,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }